import { AnySchema, ValidationError } from 'yup';

const getValidationErrors = async (
  subject: unknown,
  validationSchema: AnySchema
): Promise<ValidationError['errors']> => {
  let validationErrors: ValidationError['errors'] = [];
  try {
    await validationSchema.validate(subject, { abortEarly: false });
  } catch (err) {
    validationErrors = (err as ValidationError).errors;
  }
  return validationErrors;
};

export default getValidationErrors;
